import React, { Component } from "react";
import { Spin, message, Switch } from "antd";
import ForgotPassword from "./components/modals/ForgotPassword";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";
import { translateApiMessage } from "./utils/functions";

import englishData from "./utils/language/leStudy/english.json";
import spanishData from "./utils/language/leStudy/spanish.json";
import * as Sentry from '@sentry/react';
import { logEvent } from "./utils/analytics";

class Signin extends Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
      type1: "password",
      selectedToggleLanguage: "English",
    };
  }
  // on change inputs
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  // show hide password
  togglePassword = (num) => {
    if (num == "1") {
      this.setState({
        type1: this.state.type1 == "password" ? "text" : "password",
      });
    }
  };
  // sign in
  signinPlease = () => {
    // Get formData based on language for LE Study
    let formData = englishData;
    if (RESEARCH_TYPE == "LE Study") {
      formData =
        this.state.selectedToggleLanguage === "English"
          ? englishData
          : spanishData;
    }

    if (!this.state.email) {
      message.warning(
        formData.page.createAccount.messages.validation.emailRequired
      );
      return;
    }
    if (this.state.email && this.state.email !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(this.state.email)) {
        message.warning(formData.page.createAccount.messages.validation.emailInvalid);
        return;
      }
    }
    if (!this.state.password) {
      message.warning(
        formData.page.createAccount.messages.validation.passwordRequired
      );
      return;
    }
    let params = {
      email: this.state.email,
      password: this.state.password,
      research_type: RESEARCH_TYPE,
    };
    this.setState({ loading: true });
    Bridge.login(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          var formData = englishData;
          if (RESEARCH_TYPE == "LE Study") {
            formData =
              this.state.selectedToggleLanguage === "English"
                ? englishData
                : spanishData;
          }
          const successMessage = formData?.page?.signIn?.messages?.loginSuccess || "Logged in Successfully";

          let name = "";
          if (response.data.first_name) {
            name = response.data.first_name;
          } else if (response.data.last_name) {
            name = response.data.last_name;
          } else if (response.data.participant_email) {
            name = response.data.participant_email;
          }

          localStorage.setItem("aptoken", response.data.token);
          localStorage.setItem("ap_name", name);
          logEvent("login", { method: "email", user_name: name, email: this.state.email, ...(RESEARCH_TYPE === "LE Study" ? { language: this.state.selectedToggleLanguage } : {}) });
          localStorage.setItem("ap_id", response.data.participants_id);
          localStorage.setItem("ap_email", response.data.participant_email);

          if (RESEARCH_TYPE == "modality.ai") {
            localStorage.setItem(
              "is_multiple_accounts_present",
              response.data.multiple_accounts_present
            );
            if (response.data.multiple_accounts_present == true) {
              message.success(successMessage);
              setTimeout(() => {
                window.location.assign("/select-user-account");
              }, 500);
              return;
            } else {
              localStorage.setItem(
                "ap_participants_accounts_id",
                response.data.participants_accounts_id
              );
            }
          } else {
            localStorage.setItem(
              "ap_participants_accounts_id",
              response.data.participants_accounts_id
            );
          }
          localStorage.setItem("ap_eals_id", response.data.eals_id);
          localStorage.setItem("user_type", RESEARCH_TYPE);
          localStorage.setItem("ap_language", response.data.language);
          localStorage.setItem(
            "ap_relation_to_als",
            response.data.relation_to_als
          );
          if (response.data.date_created) {
            localStorage.setItem("ap_date_created", response.data.date_created);
          }

          message.success(successMessage);
          // RESEARCH_TYPE!='modality.ai' &&
          setTimeout(() => {
            if (response.data.consent_form_status == false) {
              window.location.assign("/consent-form");
            } else {
              window.location.assign("/dashboard");
            }
          }, 500);
        } else {
          logEvent("login_failed");
          const language = localStorage.getItem("ap_language") || this.state.selectedToggleLanguage || "English";
          message.error(translateApiMessage(response.data.message, language));
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        const formData =
          this.state.selectedToggleLanguage == "English"
            ? englishData
            : spanishData;
        message.warning(formData.page.createAccount.messages.validation.pleaseTryAgain);
        this.setState({ loading: false });
      });
  };
  handleLanguageChange = (value) => {
    this.setState({
      selectedToggleLanguage: value,
    });
  };
  render() {
    var formData = englishData;
    if (RESEARCH_TYPE == "LE Study") {
      formData =
        this.state.selectedToggleLanguage === "English"
          ? englishData
          : spanishData;
    }
    return (
      <>
        <Header selectedLanguage={this.state.selectedToggleLanguage} />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="authenitication-form">
                <div className="dark-side d-none d-sm-none d-md-none d-lg-block d-xl-block">
                  <img src={"./assets/images/dark-logo.jpg"} />
                  <p className="inner-text">
                    {formData.page.createAccount.missionStatement}
                  </p>
                </div>
                <div className="right-sides-form">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="d-flex justify-content-between">
                          <h2>{formData.page.signIn.title}</h2>
                          {RESEARCH_TYPE == "LE Study" && (
                            <div className="form-field">
                              <label style={{ width: "fit-content" }}>
                                {formData.page.signIn.form.languageLabel}{" "}
                                &nbsp;&nbsp;&nbsp;
                                <Switch
                                  checkedChildren={<b>English</b>}
                                  unCheckedChildren={<b>Spanish</b>}
                                  defaultChecked
                                  checked={
                                    this.state.selectedToggleLanguage ===
                                    "English"
                                  }
                                  onChange={(e) =>
                                    this.handleLanguageChange(
                                      e ? "English" : "Spanish"
                                    )
                                  }
                                />
                              </label>
                            </div>
                          )}
                        </div>
                        <div className="">
                          <Spin spinning={this.state.loading}>
                            <div className="form-wrapper">
                              <div className="form-field">
                                <label>
                                  <box-icon
                                    type="solid"
                                    name="envelope"
                                    color="#9e9e9e"
                                    size={
                                      window.innerWidth > 600 ? "23px" : "23px"
                                    }
                                    style={{
                                      marginTop:
                                        window.innerWidth > 600 ? 0 : -3,
                                      marginRight:
                                        window.innerWidth > 600 ? 12 : 9,
                                    }}
                                  ></box-icon>{" "}
                                  {formData.page.signIn.form.fields.email.label}
                                </label>
                                <input
                                  type="text"
                                  name="email"
                                  value={this.state.email}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <div className="form-field">
                                <label>
                                  <box-icon
                                    style={{
                                      marginTop:
                                        window.innerWidth > 600 ? 0 : -3,
                                      marginRight:
                                        window.innerWidth > 600 ? 12 : 9,
                                    }}
                                    name="lock-alt"
                                    type="solid"
                                    color="#9e9e9e"
                                    size={
                                      window.innerWidth > 600 ? "23px" : "23px"
                                    }
                                  ></box-icon>
                                  {
                                    formData.page.signIn.form.fields.password
                                      .label
                                  }
                                </label>
                                <input
                                  type={this.state.type1}
                                  name="password"
                                  value={this.state.password}
                                  onChange={this.handleChange}
                                />
                                <div
                                  className="togglePassword"
                                  onClick={() => this.togglePassword("1")}
                                >
                                  {this.state.type1 == "password" ? (
                                    <div className="show-password-icon">
                                      <box-icon
                                        name="show"
                                        color="#ffa3a3"
                                      ></box-icon>
                                    </div>
                                  ) : (
                                    <div className="show-password-icon">
                                      <box-icon
                                        name="low-vision"
                                        color="#ffa3a3"
                                      ></box-icon>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <ForgotPassword formData={formData} />
                              <center>
                                <button
                                  type="button"
                                  className="submit-button full-width"
                                  onClick={() => this.signinPlease()}
                                >
                                  <box-icon
                                    name="log-in"
                                    color="#fff"
                                    size={"20px"}
                                  ></box-icon>
                                  &nbsp;{" "}
                                  {formData.page.signIn.form.buttons.signIn}
                                </button>
                              </center>
                              {(RESEARCH_TYPE == "modality.ai" ||
                                RESEARCH_TYPE == "ECAS Study" ||
                                RESEARCH_TYPE == "LE Study") && (
                                  <span className="extra-link-with-text">
                                    {formData.page.signIn.form.links.newUser}{" "}
                                    &nbsp;
                                    <a href="/create-new-account">
                                      {
                                        formData.page.signIn.form.links
                                          .createAccount
                                      }
                                    </a>
                                  </span>
                                )}
                            </div>
                          </Spin>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer formData={formData} key={this.state.selectedToggleLanguage} />
      </>
    );
  }
}
export default Signin;
